import * as React from 'react';
import { SelectedResetter } from '../components/drag-select/SelectableGroup';
import { ShipmentSummary } from '../transportation/models/shipments/shipment-summary';

/**
 * Keeps hold of the shipments of a list that are selected by dragging over their rows, or by clicking them.
 * @param results The shipments of the page that is shown
 * @param getShipment Gets the shipment out of the row that was selected
 */
export function useShipmentSelection(results : ShipmentSummary[], getShipment : (row : any) => ShipmentSummary) {

    const [selected, setSelected]               = React.useState<ShipmentSummary[]>([]);
    const [selectedResetter]                    = React.useState(() => new SelectedResetter());

    /**
     * Handler for when the user is done selecting rows
     * @param rows The rows that are selected
     */
    const onSelectionFinish = (rows : any[]) => {

        const chosen = rows.map(getShipment).filter((x : ShipmentSummary | undefined) => !!x);

        results.forEach((itm : ShipmentSummary) => {
            itm.isChecked = chosen.indexOf(itm) >= 0;
        });

        setSelected(chosen);
    };

    /**
     * Clears the selection, as is needed when the list that was selected from is not the one that is shown any more
     */
    const resetSelection = () => {

        results.forEach((itm : ShipmentSummary) => {
            itm.isChecked = false;
        });

        setSelected([]);
        selectedResetter.reset();
    };

    return { selected, selectedResetter, onSelectionFinish, resetSelection };
}
